module.exports = __webpack_public_path__ + "img/aggregation.24e27db1.svg";